import type { ReactNode } from "react";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Button,
  ButtonTypeEnum,
  Dialog,
  DialogContent,
  Icon,
} from "@tenant/ui";
import defaultStyles from "./StaysUpsellDialog.module.scss";

interface StaysUpsellDialogProps {
  open: boolean;
  onOpen: () => void;
  onDecline: () => void;
  onDismiss: () => void;
  onConfirm: () => void;
  children?: ReactNode;
}

export const StaysUpsellDialog = ({
  open,
  onOpen,
  onDecline,
  onDismiss,
  onConfirm,
  children,
}: StaysUpsellDialogProps) => {
  const [, cn] = useModuleBEM(defaultStyles, "StaysUpsellDialog");
  const { t } = useI18nContext();

  return (
    <Dialog open={open} onOpen={onOpen} onClose={onDismiss}>
      {children}
      <DialogContent
        title={t("flightReview.addStayDialog.title")}
        titleIsVisuallyHidden
        bottomFixedContent={
          <div className={cn("actions")}>
            <Button buttonType={ButtonTypeEnum.Primary} onClick={onConfirm}>
              {t("flightReview.addStayDialog.confirm")}
            </Button>
            <Button buttonType={ButtonTypeEnum.Tertiary} onClick={onDecline}>
              {t("flightReview.addStayDialog.cancel")}
            </Button>
          </div>
        }
      >
        <Icon
          iconName={IconNameEnum.stays__active__with_background}
          className={cn("icon")}
        />
        <span className={cn("title")}>
          {t("flightReview.addStayDialog.title")}
        </span>
        {t("flightReview.addStayDialog.description")}
      </DialogContent>
    </Dialog>
  );
};
